import { html } from "htm/preact";
import { ctx, translate } from "..";
import { CartItem } from "../model";

export default function CartItemView(item: CartItem) {

    const { state, dispatch } = ctx();

    function getInventory(sku: string) {
        if (!state.inventory) return '';
        if (!state.inventory[sku] || state.inventory[sku] <= 0) {
            return translate('Out of stock');
        } else {
            return `${translate('In stock')} - ${translate('Delivery is 1-3 working days')}`;
        }
    }


    return html`<div class="card ecommerce-card">
                            <div class="item-img">
                                <a href="app-ecommerce-details.html">
                                    <img fetchpriority="low" src=${item.product.image} alt="img-placeholder"/>
                                </a>
                            </div>
                            <div class="card-body">
                                <div class="item-name">
                                    <h6 class="mb-0"><a  class="text-body">${item.product.name}</a></h6>
                                    <span class="item-company"><a href="#" class="company-name">${item.product.brand}</a></span>                                </div>
                                
                                <div class="item-quantity">
                                    <span class="quantity-title">${translate('Amount')}:</span>
                                    <div class="quantity-counter-wrapper">
                                        <div class="input-group bootstrap-touchspin">
                                            <span class="input-group-btn bootstrap-touchspin-injected">
                                                <button onclick=${() => dispatch({ type: 'quantity', id: item.id, quantity: item.quantity - 1 })} class="btn btn-primary bootstrap-touchspin-down" type="button">-</button>
                                            </span>
                                            <input onkeyup=${ev => dispatch({ type: 'quantity', id: item.id, quantity: parseInt(ev.target.value) })} value=${item.quantity} type="number" class="quantity-counter form-control"/>
                                            <span onclick=${() => dispatch({ type: 'quantity', id: item.id, quantity: item.quantity + 1 })} class="input-group-btn bootstrap-touchspin-injected">
                                                <button class="btn btn-primary bootstrap-touchspin-up" type="button">+</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-options text-center">
                                <div class="item-wrapper">
                                    <div class="item-cost">
                                        <h4 class="item-price">${item.product.price?.toFixed(2).replace(".", ",")} ${translate('USD')}</h4>
                                        <h6 class="item-name">${item.product.sku}</h6>
                                        <h6 class="item-name">${getInventory(item.product.sku)}</h6>
                                    </div>
                                </div>
                                <button onclick=${() => dispatch({ type: 'quantity', id: item.id, quantity: 0 })}  type="button" class="btn btn-light mt-1 remove-wishlist waves-effect waves-float waves-light">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x align-middle me-25"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    <span>${translate('Remove')}</span>
                                </button>
                            </div>
                        </div>`
}